import React from 'react';
import { IconButton } from '@material-ui/core';
import { Check, FileCopy } from '@material-ui/icons';
import { useStyles } from './styles';

export interface CopyEmailsButtonProps {
  animating: boolean;
  ariaLabel: string;
  onClick: () => void;
  disabled?: boolean;
}

export function CopyEmailsButton({ animating, ariaLabel, onClick, disabled }: CopyEmailsButtonProps) {
  const classes = useStyles();
  return (
    <IconButton
      size="small"
      type="button"
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      aria-label={ariaLabel}
      className={`${classes.copyEmailButton} ${animating ? classes.copyEmailButtonPulse : ''}`}
    >
      <span className={`${classes.copyEmailIcon} ${animating ? classes.copyEmailIconPop : ''}`}>
        {animating ? <Check fontSize="small" /> : <FileCopy fontSize="small" />}
      </span>
    </IconButton>
  );
}
